<template>
  <v-text-field
    class="pf-phone-number"
    v-bind="$attrs"
    v-on="$listeners"
    v-model="numberFormatted"
    :success="isValid"
    @keydown="preventKeys($event)"
    @keyup="checkKey($event)"
    @focus="onFocus()"
    @blur="onBlur()"
  >

    <!-- Prepend Inner Slot -->
    <template v-slot:prepend-inner>
      <div
        class="pf-prepend-inner-icon-wrapper"
        :style="$slots['prepend-inner'] ? 'margin-right: 12px' : ''"
        v-if="$attrs['prepend-inner-icon']"   
      >
        <slot name="prepend-inner">
          <div class="v-input__icon v-input__icon--prepend-inner">
            <v-icon 
              class="pf-prepend-inner-icon"
              :class="prependInnerIconClasses">{{ $attrs['prepend-inner-icon'] }}
            </v-icon>
          </div>
        </slot>
      </div>
      <!-- Code Select -->
      <div class="pf-code-wrapper">
        <v-select class="pf-code" eager :menu-props="{maxHeight: 500}"
          :items="regionCodes"
          v-model="regionCodeComputed"
        >
          <template v-slot:selection>
            {{ callingCode }}
          </template>
        </v-select>
      </div>
      <!-- END Code Select -->
    </template>
    <!-- END Prepend Inner Slot -->

    <!-- Append Slot -->
    <template v-slot:append>
      <slot name="append"></slot>
    </template>
    <!-- END Append Slot -->

    <!-- Remaining slots to follow... -->

  </v-text-field>
</template>

<script>
import Apn from 'awesome-phonenumber'
import regionCodes from '../regionCodes'
import Sanitise from '../mixins/Sanitise'
export default {
  props: {
    region: String,
    format: String,
    value: String
  },
  mixins: [
    Sanitise
  ],
  data() {
    return {
      regionCodes,
      regionCode: 'ZA',
      numberFormat: 'national',
      ApnInstance: null,
      number: '',
      focused: false,
      dirty: false
    }
  },
  computed: {
    callingCode() {
      return '+' + Apn.getCountryCodeForRegionCode(this.regionCodeComputed)
    },
    regionCodeComputed: {
      get() {
        return this.regionCode
      },
      set(val) {
        this.regionCode = val
        this.ApnInstance = Apn(this.number, this.regionCode)
      }
    },
    numberFormatted: {
      get() {
        return this.number
      },
      set(val) {
        val = this.sanitise(val)
        this.ApnInstance = Apn(val, this.regionCodeComputed)
        const numberFormatted = this.ApnInstance.getNumber(this.numberFormat)
        this.number = numberFormatted !== undefined ? numberFormatted : val
        this.$emit('updated', this.getApnInstanceData())
        this.dirty = true
      }
    },
    isValid() {
      const valid = this.ApnInstance.isValid()
      this.$emit('valid', valid)
      return valid
    },
    prependInnerIconClasses() {
      return (
        (this.dirty ? 'dirty ' : '') +
        (this.focused ? 'focused' : '')
      )
    }
  },
  methods: {
    getApnInstanceData() {
      return {
        isValid: this.ApnInstance.isValid(),
        isMobile: this.ApnInstance.isMobile(),
        canBeInternationallyDialled: this.ApnInstance.canBeInternationallyDialled(),
        number: this.ApnInstance.getNumber(),
        numberE164: this.ApnInstance.getNumber('e164'),
        numberInternational: this.ApnInstance.getNumber('international'),
        numberNational: this.ApnInstance.getNumber('national'),
        numberRfc3966: this.ApnInstance.getNumber('rfc3966'),
        numberSignificant: this.ApnInstance.getNumber('significant'),
        regionCode: this.ApnInstance.getRegionCode(),
        countryCode: this.ApnInstance.getCountryCode()
      }
    },
    onFocus() {
      this.focused = true
    },
    onBlur() {
      this.focused = false
    }
  },
  created() {
    //Instantiate Apn
    this.ApnInstance = Apn(this.number, this.regionCode)

    /** Set props ********************/
    if (this.region) {
      this.regionCode = this.region
    }
    if (this.format) {
      this.numberFormat = this.format
    }
    if (this.value) {
      this.number = this.value
    }
  },
  watch: {
    /** Update props live ************/
    region(code) {
      this.regionCodeComputed = code
    },
    format(type) {
      this.numberFormat = type
      this.numberFormatted = this.number
    }
  }
}
</script>

<style>

  .pf-phone-number:not(.v-text-field--outlined) .v-text-field__slot label.v-label--active {
    margin-left: -64px;
  }

   /* Prepend Inner Icon *****************/
   .pf-prepend-inner-icon-wrapper {
     margin-right: 12px;
   }

  .v-icon.pf-prepend-inner-icon.dirty,
  .v-icon.pf-prepend-inner-icon.focused {
    color: inherit !important;
    caret-color: inherit !important;
  }

  /* Country Code ************************/
  .pf-code-wrapper {
    width: 60px;
  }

  .pf-code {
    position: absolute !important;
    width: 60px;
    z-index: 2;
    padding-top: 0 !important;
    height: 38px;
  }

  /* Outlined */
  .v-text-field--outlined:not(.v-input--dense) .pf-code,
  .v-text-field--outlined:not(.v-input--dense) .pf-code .v-input__append-inner {
    margin-top: 3px !important;
  }

  .v-application .pf-code.v-input,
  .pf-code .v-input__control,
  .v-input__slot .pf-code .v-input__append-inner .v-input__icon--append .v-icon {
    color: rgba(0, 0, 0, 0.3) !important;
  }

  .pf-code .v-input__slot {
    margin-top: -8px;
  }

  .pf-code .v-input__slot:before,
  .pf-code .v-input__slot:after {
    display: none !important;
  }

  .pf-code .v-select__selection {
    margin-right: 0 !important;
  }

  .pf-code .v-input__append-inner {
    width: 20px;
    padding-left: 0 !important;
  }
</style>